<header class="navbar">
  <div class="navbar-left">
    <p class="navbar-title">{{ pageTitle() }}</p>
  </div>
  <div class="navbar-right">
    @if (showUserNavbarActions()) {
      <button
        type="button"
        class="btn-icon-only btn-icon-only--wishlist-mobile"
        aria-label="Criar lista de desejos"
        (click)="onCreateWishlist()"
      >
        <!--
          SVG inline (não <img>): o "+" precisa seguir o tema. Como <img> a cor
          ficaria presa ao `stroke="black"` do ficheiro. O círculo mantém o
          gradiente da marca; o traço usa `--text-on-primary`.
        -->
        <svg
          class="wishlist-mobile-icon"
          width="28"
          height="28"
          viewBox="0 0 28 28"
          fill="none"
          aria-hidden="true"
        >
          <rect width="28" height="28" rx="14" fill="url(#navbarCreateWishlistGradient)" />
          <path
            class="wishlist-mobile-icon__plus"
            d="M14 9.1001V18.9001M9.10001 14.0001H18.9"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <defs>
            <linearGradient
              id="navbarCreateWishlistGradient"
              x1="0.0503597"
              y1="0"
              x2="28.6178"
              y2="0.591427"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#FF761A" />
              <stop offset="1" stop-color="#FF531A" />
            </linearGradient>
          </defs>
        </svg>
      </button>
      <div class="navbar-search-desktop">
        <app-people-search-bar />
      </div>
      <button
        type="button"
        class="btn-icon-only btn-icon-only--search-mobile"
        aria-label="Buscar pessoas"
        [attr.aria-expanded]="mobileSearchOpen()"
        (click)="openMobileSearch($event)"
      >
        <svg
          class="search-mobile-icon"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          stroke-width="2"
          aria-hidden="true"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
          />
        </svg>
      </button>
      <button type="button" class="btn-cta" (click)="onCreateWishlist()">
        <!-- SVG inline (não <img>) para o traço seguir a cor do texto do botão. -->
        <svg
          class="btn-icon"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
          aria-hidden="true"
        >
          <path d="M12 8V16M8 12H16M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z" />
        </svg>
        Criar Lista de Desejos
      </button>
    }
    @if (showUserNavbarActions() && authService.isAuthenticated()) {
      <div class="notif-wrap" #notifRoot>
        <button
          type="button"
          class="btn-icon-only btn-icon-only--notif"
          aria-label="Notificações"
          [attr.aria-expanded]="notificationsOpen()"
          (click)="toggleNotifications($event)"
        >
          @if (unreadCount() > 0) {
            <span class="notif-badge" aria-hidden="true"></span>
          }
          <svg
            class="bell-icon"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            stroke-width="2"
            aria-hidden="true"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"
            />
          </svg>
        </button>
        @if (notificationsOpen()) {
          <div class="notif-dropdown" role="region" aria-label="Notificações">
            <div class="notif-dropdown__head">
              <span class="notif-dropdown__title">Notificações</span>
            </div>
            @if (notificationsLoading()) {
              <p class="notif-dropdown__message">Carregando…</p>
            } @else if (notificationsError()) {
              <p class="notif-dropdown__message notif-dropdown__message--error">
                {{ notificationsError() }}
              </p>
            } @else if (notifications().length === 0) {
              <p class="notif-dropdown__message">Nenhuma notificação.</p>
            } @else {
              <ul class="notif-dropdown__list" role="list">
                @for (n of notifications(); track n.id) {
                  <li class="notif-card" role="listitem">
                    <div class="notif-card__inner">
                      @if (n.actionUsername) {
                        <button
                          type="button"
                          class="notif-card__avatar-btn"
                          (click)="navigateToUser(n.actionUsername, $event)"
                          [attr.aria-label]="'Ver perfil de @' + n.actionUsername"
                        >
                          @if (n.actionUserProfilePicture) {
                            <img
                              class="notif-card__avatar"
                              [src]="n.actionUserProfilePicture"
                              alt=""
                              width="36"
                              height="36"
                            />
                          } @else {
                            <span class="notif-card__avatar notif-card__avatar--placeholder" aria-hidden="true">
                              {{ n.actionUsername.charAt(0).toUpperCase() }}
                            </span>
                          }
                        </button>
                      }
                      <div class="notif-card__content">
                        @if (n.message) {
                          <p class="notif-card__body">{{ n.message }}</p>
                        }
                        @if (formatNotificationDate(n.createdAt); as when) {
                          <p class="notif-card__meta">{{ when }}</p>
                        }
                      </div>
                    </div>
                  </li>
                }
              </ul>
            }
          </div>
        }
      </div>
    }
  </div>
</header>

@if (mobileSearchOpen()) {
  <div
    class="mobile-search-overlay"
    role="dialog"
    aria-modal="true"
    aria-label="Buscar pessoas"
  >
    <div class="mobile-search-overlay__header">
      <button
        type="button"
        class="mobile-search-overlay__close"
        (click)="closeMobileSearch()"
      >
        Fechar
      </button>
    </div>
    <div class="mobile-search-overlay__content">
      <app-people-search-bar
        [stretch]="true"
        searchPlaceholder="Buscar pessoas"
      />
    </div>
  </div>
}
